export default {
  totalCharacters: 200,
  listTimeDuration: [
    { id: 1, name: "1 min" },
    { id: 5, name: "5 min" },
    { id: 10, name: "10 min" },
    { id: 15, name: "15 min" },
    { id: "free", name: "Free Time" },
  ],
  selectedTimeDuration: "free",

  // until some DRY solution comes up
  lessons: [
    // ROW 1

    { title: "Lesson 1", name: "ि र" },
    { title: "Lesson 2", name: "् क" },
    { title: "Lesson 3", name: "ि र ् क" },
    { title: "Lesson 4", name: "े त" },
    { title: "Lesson 5", name: "ो च" },
    { title: "Lesson 6", name: "े त ो च" },
    { title: "Lesson 7", name: "ु प ट" },
    {
      title: "Lesson 8",
      name: "ि र ् क े त ो च ु प ट",
      key: "बीच वाली पंक्ति",
    },

    // ROW 1 without shift

    { title: "Lesson 9", name: "इ ऱ" },
    { title: "Lesson 10", name: "अ ख" },
    { title: "Lesson 11", name: "इ ऱ अ ख" },
    { title: "Lesson 12", name: "ए थ" },
    { title: "Lesson 13", name: "ओ छ" },
    { title: "Lesson 14", name: "ए थ ओ छ" },
    { title: "Lesson 15", name: "उ फ ठ" },
    {
      title: "Lesson 16",
      name: "इ ऱ अ ख ए थ ओ छ उ फ ठ",
      key: "बीच वाली पंक्ति + शिफ्ट",
    },

    // ROW 2

    { title: "Lesson 17", name: "ी ह" },
    { title: "Lesson 18", name: "ा ग" },
    { title: "Lesson 19", name: "ी ह ा ग" },
    { title: "Lesson 20", name: "ै द" },
    { title: "Lesson 21", name: "ौ ज" },
    { title: "Lesson 22", name: "ै द ौ ज" },
    { title: "Lesson 23", name: "ू ड" },
    { title: "Lesson 24", name: "ब ़" },
    { title: "Lesson 25", name: "ू ब ड ़" },
    {
      title: "Lesson 26",
      name: "ी ह ा ग ै द ौ ज ू ब ू ब ड ़",
      key: "ऊपर वाली पंक्ति",
    },

    // ROW 2 without shift

    { title: "Lesson 27", name: "ई ङ" },
    { title: "Lesson 28", name: "आ घ" },
    { title: "Lesson 29", name: "ई ङ आ घ" },
    { title: "Lesson 30", name: "ऐ ध" },
    { title: "Lesson 31", name: "औ झ" },
    { title: "Lesson 32", name: "ऐ ध औ झ" },
    { title: "Lesson 33", name: "ऊ ढ" },
    { title: "Lesson 34", name: "भ ञ" },
    { title: "Lesson 35", name: "ऊ ढ भ ञ" },
    {
      title: "Lesson 36",
      name: "ई ङ आ घ ऐ ध औ झ ऊ भ ढ ञ",
      key: "ऊपर वाली पंक्ति + शिफ्ट",
    },

    // ROW 3

    { title: "Lesson 37", name: "न स" },
    { title: "Lesson 38", name: "म ," },
    { title: "Lesson 39", name: "न स म ," },
    { title: "Lesson 40", name: "ं ." },
    { title: "Lesson 41", name: "ॆ य" },
    { title: "Lesson 42", name: "ं . ॆ य" },
    { title: "Lesson 43", name: "व ल" },
    {
      title: "Lesson 44",
      name: "न स म , ं . ॆ य व ल",
      key: "नीचे वाली पंक्ति",
    },

    // ROW 3 without shift

    { title: "Lesson 45", name: "ऩ श" },
    { title: "Lesson 46", name: "ण ष" },
    { title: "Lesson 47", name: "ऩ श ण ष" },
    { title: "Lesson 48", name: "ँ ।" },
    { title: "Lesson 49", name: "ऎ य़" },
    { title: "Lesson 50", name: "ँ । ऎ य़" },
    { title: "Lesson 51", name: "ऴ ळ" },
    {
      title: "Lesson 52",
      name: "ऩ श ण ष ँ । ऎ य़ ऴ ळ",
      key: "नीचे वाली पंक्ति + शिफ्ट",
    },
  ],
  learnLessons: [
    {
      id: "R1",
      name: "बीच वाली पंक्ति",
      withoutShift: [
        { title: "Lesson 1", name: "ि र" },
        { title: "Lesson 2", name: "् क" },
        { title: "Lesson 3", name: "ि र ् क" },
        { title: "Lesson 4", name: "े त" },
        { title: "Lesson 5", name: "ो च" },
        { title: "Lesson 6", name: "े त ो च" },
        { title: "Lesson 7", name: "ु प ट" },
        {
          title: "Lesson 8",
          name: "ि र ् क े त ो च ु प ट",
          key: "बीच वाली पंक्ति",
        },
      ],
      withShift: [
        { title: "Lesson 9", name: "इ ऱ" },
        { title: "Lesson 10", name: "अ ख" },
        { title: "Lesson 11", name: "इ ऱ अ ख" },
        { title: "Lesson 12", name: "ए थ" },
        { title: "Lesson 13", name: "ओ छ" },
        { title: "Lesson 14", name: "ए थ ओ छ" },
        { title: "Lesson 15", name: "उ फ ठ" },
        {
          title: "Lesson 16",
          name: "इ ऱ अ ख ए थ ओ छ उ फ ठ",
          key: "बीच वाली पंक्ति + शिफ्ट",
        },
      ],
    },
    {
      id: "R2",
      name: "ऊपर वाली पंक्ति",
      withoutShift: [
        { title: "Lesson 17", name: "ी ह" },
        { title: "Lesson 18", name: "ा ग" },
        { title: "Lesson 19", name: "ी ह ा ग" },
        { title: "Lesson 20", name: "ै द" },
        { title: "Lesson 21", name: "ौ ज" },
        { title: "Lesson 22", name: "ै द ौ ज" },
        { title: "Lesson 23", name: "ू ड" },
        { title: "Lesson 24", name: "ब ़" },
        { title: "Lesson 25", name: "ू ब ड ़" },
        {
          title: "Lesson 26",
          name: "ी ह ा ग ै द ौ ज ू ब ू ब ड ़",
          key: "ऊपर वाली पंक्ति",
        },
      ],
      withShift: [
        { title: "Lesson 27", name: "ई ङ" },
        { title: "Lesson 28", name: "आ घ" },
        { title: "Lesson 29", name: "ई ङ आ घ" },
        { title: "Lesson 30", name: "ऐ ध" },
        { title: "Lesson 31", name: "औ झ" },
        { title: "Lesson 32", name: "ऐ ध औ झ" },
        { title: "Lesson 33", name: "ऊ ढ" },
        { title: "Lesson 34", name: "भ ञ" },
        { title: "Lesson 35", name: "ऊ ढ भ ञ" },
        {
          title: "Lesson 36",
          name: "ई ङ आ घ ऐ ध औ झ ऊ भ ढ ञ",
          key: "ऊपर वाली पंक्ति + शिफ्ट",
        },
      ],
    },
    {
      id: "R3",
      name: "नीचे वाली पंक्ति",
      withoutShift: [
        { title: "Lesson 37", name: "न स" },
        { title: "Lesson 38", name: "म ," },
        { title: "Lesson 39", name: "न स म ," },
        { title: "Lesson 40", name: "ं ." },
        { title: "Lesson 41", name: "ॆ य" },
        { title: "Lesson 42", name: "ं . ॆ य" },
        { title: "Lesson 43", name: "व ल" },
        {
          title: "Lesson 44",
          name: "न स म , ं . ॆ य व ल",
          key: "नीचे वाली पंक्ति",
        },
      ],
      withShift: [
        { title: "Lesson 45", name: "ऩ श" },
        { title: "Lesson 46", name: "ण ष" },
        { title: "Lesson 47", name: "ऩ श ण ष" },
        { title: "Lesson 48", name: "ँ ।" },
        { title: "Lesson 49", name: "ऎ य़" },
        { title: "Lesson 50", name: "ँ । ऎ य़" },
        { title: "Lesson 51", name: "ऴ ळ" },
        {
          title: "Lesson 52",
          name: "ऩ श ण ष ँ । ऎ य़ ऴ ळ",
          key: "नीचे वाली पंक्ति + शिफ्ट",
        },
      ],
    },
  ],
};
